<!-- header start -->
<header class="sticky" [ngClass]="class">
    <!-- <div class="mobile-fix-option"></div> -->
    <div class="top-header">
        <div class="container">
          <div class="row">
            <div class="d-flex justify-content-center">
              <div class="header-contact">
                <ul>
                  <li>NATIONWIDE SHIPPING & FREE COLLECTION</li>
                  <!-- <li><i class="fa fa-phone" aria-hidden="true"></i>Call Us: 123 - 456 - 7890</li> -->
                </ul>
              </div>
            </div>
          </div>
        </div>
    </div>
    <div class="header-wrapper">
      <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <div class="main-menu border-section border-top-0 d-flex justify-content-between ">
                  <app-left-menu></app-left-menu>
                    <div>
                      <div class="brand-logo layout2-logo ">
                        <a [routerLink]="['/']">
                            <img [src]="themeLogo" class="img-fluid" alt="logo" height="100px" width="100px">
                        </a>
                    </div>
                    </div>
                    <div *ngIf="!isMobile">
                      <ul class="desktop-menu" >
                        <li class="menu-option" *ngFor="let menuItem of menuItems" [routerLink]="menuItem.path" [queryParams]="{'category': menuItem.parameter}">{{menuItem.title}}</li>
                      </ul>
                    </div>
                    <div class="menu-right pull-right justify-content-end" *ngIf="!isMobile">
                      <app-settings></app-settings>
                    </div>
                </div>
                <div class="main-menu border-section border-top-0 d-flex" style="height: 0px;" *ngIf="isMobile">
                <app-settings class="menu-right pull-right justify-content-end" ></app-settings>
                </div>
            </div>
        </div>
      </div>
    </div>

</header>
<!-- header end -->